/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';
// Caminho antigo da aba (router.tsx:1672-1719) vira `?tab=` (S29).
export const Route = createFileRoute('/_app/cadastro/produtos-credito/$productId/orgao')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/cadastro/produtos-credito/$productId',
      params,
      search: { tab: 'orgao' },
    });
  },
});
